<template>
  <div class="p-grid">
    <div class="p-col-12 p-sm-6 p-xl-3">
      <AppWidgetCount
        title="Em Caixa"
        :value="$toCurrency(values.balance)"
        valueColor="white"
        valueBackgroundColor="#48A7FF"
        :loading="loading"
      />
    </div>
    <div class="p-col-12 p-sm-6 p-xl-3">
      <AppWidgetCount
        title="Receitas"
        valueColor="white"
        valueBackgroundColor="#00C52B"
        :value="$toCurrency(values.income)"
        :loading="loading"
      />
    </div>
    <div class="p-col-12 p-sm-6 p-xl-3">
      <AppWidgetCount
        title="Despesas"
        valueColor="white"
        valueBackgroundColor="#FF5757"
        :value="$toCurrency(values.expense)"
        :loading="loading"
      />
    </div>
    <div class="p-col-12 p-sm-6 p-xl-3">
      <AppWidgetCount
        title="Lucro"
        valueColor="white"
        valueBackgroundColor="#001AFF"
        :value="`${values.profit || 0}%`"
        :loading="loading"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    values: {
      type: Object,
    },
    loading: Boolean,
  },
};
</script>

<style scoped>
</style>
